var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNextjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_285)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_316_285",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4399 64C50.1131 64 64.4399 49.6731 64.4399 32C64.4399 14.3269 50.1131 0 32.4399 0C14.7668 0 0.439941 14.3269 0.439941 32C0.439941 49.6731 14.7668 64 32.4399 64Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_316_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4399 62.9333C49.5239 62.9333 63.3733 49.084 63.3733 32C63.3733 14.916 49.5239 1.06665 32.4399 1.06665C15.3559 1.06665 1.50659 14.916 1.50659 32C1.50659 49.084 15.3559 62.9333 32.4399 62.9333Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5983 56.0071L25.0237 19.2H19.6399V44.7893H23.947V24.6697L50.2173 58.6115C51.4027 57.8183 52.532 56.9475 53.5983 56.0071Z",
    fill: "url(#paint0_linear_316_285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5955 19.2H41.3289V44.8H45.5955V19.2Z",
    fill: "url(#paint1_linear_316_285)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_285",
    x1: 39.1954,
    y1: 41.4222,
    x2: 51.8177,
    y2: 57.0666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_285",
    x1: 43.4622,
    y1: 19.2,
    x2: 43.3907,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.439941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextjs);
export default __webpack_public_path__ + "static/media/icon-nextjs.8a378a178974cb6115fbdca1611126e6.svg";
export { ForwardRef as ReactComponent };